import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { FALLBACK_CATEGORIES } from "../../lib/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Categories = ({ onQuote }) => {
  const [categories, setCategories] = useState(FALLBACK_CATEGORIES);

  useEffect(() => {
    axios
      .get(`${API}/categories`)
      .then((res) => Array.isArray(res.data) && res.data.length && setCategories(res.data))
      .catch(() => {});
  }, []);

  return (
    <section id="catalog" data-testid="categories-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-primary mb-4">/ 01 — The Catalog</p>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.9]">
              What We<br />Supply
            </h2>
          </div>
          <p className="max-w-sm font-body text-base text-muted-foreground">
            Browse the categories below and request a quote for exactly what your operation needs. If it&apos;s not listed — we&apos;ll still source it.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-border">
          {categories.map((cat, i) => (
            <motion.article
              key={cat.slug}
              data-testid={`category-card-${cat.slug}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group relative border-r border-b border-border p-6 md:p-8 flex flex-col min-h-[340px]"
            >
              <div className="relative h-40 mb-6 overflow-hidden bg-muted">
                <img
                  src={cat.image}
                  alt={cat.title}
                  loading="lazy"
                  className="h-full w-full object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-100 transition-all duration-500"
                />
              </div>
              <span className="font-mono text-xs text-muted-foreground mb-2">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-heading text-2xl font-bold tracking-tight mb-2 group-hover:text-primary transition-colors">
                {cat.title}
              </h3>
              <p className="font-body text-sm text-muted-foreground leading-relaxed mb-6 flex-1">
                {cat.blurb}
              </p>
              <button
                data-testid={`category-quote-${cat.slug}`}
                onClick={() => onQuote(cat.title)}
                className="inline-flex items-center justify-between w-full h-11 px-4 border border-border font-mono text-xs uppercase tracking-[0.15em] text-foreground group-hover:bg-primary group-hover:text-primary-foreground group-hover:border-primary transition-colors duration-200"
              >
                Request Quote <ArrowUpRight size={16} />
              </button>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
